import { render, staticRenderFns } from "./DetailHasilUjianPSIKOTES.vue?vue&type=template&id=67b40c66&scoped=true"
import script from "./DetailHasilUjianPSIKOTES.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianPSIKOTES.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianPSIKOTES.vue?vue&type=style&index=0&id=67b40c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b40c66",
  null
  
)

export default component.exports